import {GenericModalService} from "../generic-modal/generic-modal.service";
import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {forkJoin} from "rxjs";
import * as pubsub from "pubsub-js"
import {FeedbackService} from "../feedback/feedback.service";
import {FeedbackMessageTypeEnum} from "./feedback-message-type.enum";

@Injectable({
    providedIn: 'root'
})
export class ThanksFeedbackService {

    private urlBda = ''

    constructor(private genericModalService: GenericModalService,
                private translateService: TranslateService,
                private feedbackService: FeedbackService) {

        pubsub.subscribe('modalClosed', () => {
            window.location.href = this.urlBda;
        })
    }

    openFeedbackThanksModal(feedbackMessageType: FeedbackMessageTypeEnum) {
        const messagesModal$ = this.translateService.get('feedback.modal');
        const getUrlFeedback$ = this.feedbackService.getURL();
        forkJoin([messagesModal$, getUrlFeedback$])
            .subscribe(([messagesModal$, urls]) => {
                this.urlBda = urls.message;
                let title = ''
                let body = ''
                let typeModal = ''
                if (feedbackMessageType == FeedbackMessageTypeEnum.SUCCESS) {
                    title = messagesModal$.title;
                    body = messagesModal$.body;
                    typeModal = 'SUCCESS'
                }
                if(feedbackMessageType == FeedbackMessageTypeEnum.ERROR){
                    title = messagesModal$.titleError;
                    body = messagesModal$.bodyError;
                    typeModal = 'ERROR'
                }
                this.genericModalService.open(title, body,typeModal)
            });
    }

}
